export default {
  search: {
    pagination: {
      page_quantity: 'Paginate up to',
      show_quantity_records: 'Displaying {{model}} {{beginRecords}} - {{endRecords}} of {{total}} in total',
      show_total_records: 'Displaying {{total}} {{model}}'
    },
    new_pagination: {
      show_quantity_records: '{{beginRecords}} - {{endRecords}} of {{total}} in total',
    },
    filter: {
      badge_content: {
        filter_searched: 'Your search parameters are:',
        text_searched_title: 'The text you searched for was:',
        filter_configuration: 'Filter configuration',
        validation_message: 'Please type at least 3 characters',
        hint: ' Rename your search and save it'
      }
    }
  }
};
